import React from "react";

export const ToggleTagControl = (props) => {
    if (!props.item) {
        throw new Error("Item Property is required");
    }

    const onClick = () => {
        if (props.onClick) {
            props.onClick(this.props.item);
        }
    };

    return (
        <div className="tag" onClick={onClick}>
            <div className={props.selected ? "selected" : ""}>
                <div className="content">{props.item.name}</div>
            </div>
        </div>
    );
};
